// src/components/Alerts.js

import React from "react";
import "./Alerts.css";
import MultiStyleButton from "./MultiStyleButton";

const Alerts = ({ type, message, onConfirm, onCancel }) => {
  const renderButtons = () => {
    switch (type) {
      case "windowConfirm":
        return (
          <div className="alert-buttons">
            <MultiStyleButton
              label="Confirm"
              buttonType="approve"
              onClick={onConfirm}
            />
            <MultiStyleButton
              label="Cancel"
              buttonType="cancel"
              onClick={onCancel}
            />
          </div>
        );
      case "greenInfo":
      case "redInfo":
        return (
          <div className="alert-buttons">
            <MultiStyleButton
              label="OK"
              buttonType="approve"
              onClick={onConfirm}
            />
          </div>
        );
      case "retry":
        return (
          <div className="alert-buttons">
            <MultiStyleButton
              label="Retry"
              buttonType="approve"
              onClick={onConfirm}
            />
            {onCancel && (
              <MultiStyleButton
                label="Cancel"
                buttonType="cancel"
                onClick={onCancel}
              />
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`alert-overlay ${type}`}>
      <div className="alert-box">
        <p className="alert-message">{message}</p>
        {renderButtons()}
      </div>
    </div>
  );
};

export default Alerts;
